import React from 'react';
import PropTypes from 'prop-types';
import {
  Section,
  SpecsGrid,
  SpecCard,
  SpecHeader,
  SpecIcon,
  SpecLabel,
  SpecValue,
  StyledCopyButton,
} from './TyreSpecs.style';

const getSpecIcon = (label) => {
  const iconMap = {
    EAN: 'mdi-barcode',
    Dimenzija: 'mdi-ruler',
    'Razmerje višine': 'mdi-aspect-ratio',
    'Premer platišča (palci)': 'mdi-diameter',
    'Premer platišča (mm)': 'mdi-diameter-variant',
    'Širina platišča': 'mdi-arrow-expand-horizontal',
    'Indeks obremenitve': 'mdi-weight',
    Nosilnost: 'mdi-weight-kilogram',
    'Maks. hitrost': 'mdi-speedometer',
    'Maks. obremenitev': 'mdi-weight-lifter',
    Sezona: 'mdi-weather-partly-cloudy',
    'Dizajn bočnice': 'mdi-palette',
    '3PMSF simbol': 'mdi-snowflake',
    'M+S oznaka': 'mdi-label',
    Tiha: 'mdi-volume-off',
    'EV oznaka': 'mdi-ev-station',
    'Globina profila': 'mdi-tire',
    'Poreklo izdelka': 'mdi-map-marker',
    'Tip vozila': 'mdi-car',
    Aplikacija: 'mdi-application',
    'Odobrena platišča': 'mdi-check-circle',
    'OE indikator': 'mdi-tag',
    'OE proizvajalec': 'mdi-factory',
  };
  return iconMap[label] || 'mdi-information';
};

const shouldShowCopy = (label) => {
  return ['EAN', 'Dimenzija', 'Indeks obremenitve'].includes(label);
};

const TyreSpecs = ({specs}) => {
  const specsArray = [
    {label: 'EAN', value: specs.ean},
    {label: 'Dimenzija', value: specs.dimensionMetric},
    {label: 'Razmerje višine', value: specs.aspectRatio},
    {label: 'Premer platišča (palci)', value: specs.rimDiameterInch},
    {label: 'Premer platišča (mm)', value: specs.rimDiameterMm},
    {label: 'Širina platišča', value: specs.rimWidth},
    {label: 'Indeks obremenitve', value: specs.loadSpeedIndex},
    {label: 'Nosilnost', value: specs.loadCapacity},
    {label: 'Maks. hitrost', value: specs.maxSpeed},
    {label: 'Maks. obremenitev', value: specs.maxLoad},
    {label: 'Sezona', value: specs.season},
    {label: 'Dizajn bočnice', value: specs.sidewallDesign},
    {label: '3PMSF simbol', value: specs.snowflakeSymbol ? 'Da' : 'Ne'},
    {label: 'M+S oznaka', value: specs.mSMark ? 'Da' : 'Ne'},
    {label: 'Tiha', value: specs.silent ? 'Da' : 'Ne'},
    {label: 'EV oznaka', value: specs.zz_elec_veh ? 'Da' : 'Ne'},
    {label: 'Globina profila', value: specs.treadDepth && `${specs.treadDepth} mm`},
    {label: 'Poreklo izdelka', value: specs.productionOrigin},
    {label: 'Tip vozila', value: specs.vehicleType},
    {label: 'Aplikacija', value: specs.application},
    {label: 'Odobrena platišča', value: specs.approvedRims},
    {label: 'OE indikator', value: specs.oeIndicator},
    {label: 'OE proizvajalec', value: specs.oeManufacture},
  ];

  const filteredSpecs = specsArray.filter(
    (spec) =>
      spec.value !== null && spec.value !== undefined && spec.value !== ''
  );

  if (filteredSpecs.length === 0) return null;

  return (
    <Section>
      <SpecsGrid>
        {filteredSpecs.map((spec, index) => (
          <SpecCard key={index}>
            <SpecHeader>
              <SpecIcon className={`mdi ${getSpecIcon(spec.label)}`} />
              <SpecLabel>{spec.label}</SpecLabel>
            </SpecHeader>
            <SpecValue>
              <span>{spec.value}</span>
              {shouldShowCopy(spec.label) && (
                <StyledCopyButton
                  className="copy-button"
                  text={String(spec.value)}
                  compact
                />
              )}
            </SpecValue>
          </SpecCard>
        ))}
      </SpecsGrid>
    </Section>
  );
};

TyreSpecs.propTypes = {
  specs: PropTypes.object.isRequired,
};

export default TyreSpecs;
